import { ComponentFactoryResolver, Injectable, Injector, ReflectiveInjector, ViewContainerRef } from '@angular/core';
import { ComponentRef } from '@angular/core/src/render3';
import { Observable, ReplaySubject } from 'rxjs';
import { INDRAModalComponent } from '../modal.indra.component';
import scrollLock from 'scroll-lock';

@Injectable({ providedIn: 'root' })
export class MultipleModalService {
	private vcRef: ViewContainerRef;
	private injector: Injector;
	public activeInstances: number = 0;
	htmlElement = document.getElementsByTagName('html');
	
	modals = [];

	constructor(
		private resolver: ComponentFactoryResolver
	) {
	}

	registerViewContainerRef(vcRef: ViewContainerRef): void {
		this.vcRef = vcRef;
	}

	registerInjector(injector: Injector): void {
		this.injector = injector;
	}

	create<T>(component: any, ...parameters: any[]): Observable<ComponentRef<T>> {

		const componentRef$ = new ReplaySubject();

		const componentModalFactory = this.resolver.resolveComponentFactory(INDRAModalComponent);
		const componentFactory = this.resolver.resolveComponentFactory(component);

		const childInjector = ReflectiveInjector.resolveAndCreate([], this.injector);

		const componentRef = this.vcRef.createComponent(componentModalFactory, this.activeInstances, childInjector);
		setTimeout(() => {
			componentRef.instance.content = componentFactory.componentType;
			componentRef.instance.params = parameters;
			componentRef.instance.loadComponentMultiples();
		}, 10);

		this.activeInstances++;
		componentRef.instance['componentIndex'] = this.activeInstances;

		componentRef.instance['destroy'] = () => {
			this.activeInstances--;
			componentRef.destroy();
			this.prevModalLock();
		};

		this.modals.push(componentRef);
		componentRef$.next(componentRef);
		componentRef$.complete();

		return <Observable<ComponentRef<T>>>componentRef$.asObservable();
	}

	closeAll() {
		for (const modal of this.modals) modal.destroy();
		this.modals = [];
	}
	
	private prevModalLock() {
		// Disable scroll on body
		if (this.activeInstances > 0) {
			if (!this.htmlElement[0].classList.contains('no-scroll'))
				this.htmlElement[0].classList.add('no-scroll');
			scrollLock.hide();
		}
	}
}
